import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getProcessTaskByCriteria(body = { keyword: '' }) {
        return Api().post('/ProcessTask/GetProcessTaskByCriteria', body);
    },
    /*  2. Get one column */
    getProcessTask(id) {
        return Api().get(`/ProcessTask/${id}`);
    },
    /*  3. Create one column */
    saveProcessTask(body) {
        return Api().post(`/ProcessTask`, body);
    },
    /*  4. Delete one or more columns */
    deleteProcessTask(body) {
        return Api().post(`/ProcessTask/DeleteProcessTask`, body);
    },
    /*  5. post one or more columns */
    postProcessTask(body) {
        return Api().post(`/ProcessTask/PostProcessTask`, body);
    },
    saveSubApplicationID(body) {
        return Api().post(`/ProcessTask/SaveSubApplicationID`, body);
    }
};
